import { Dispatch } from 'redux'
import {
  add as addAction,
  set as setAction,
  setLoading,
  update as updateAction
} from 'states/dux/message/actions'
import { Payload } from 'states/dux/message/types'
import { Action } from 'states/types'
import { NivosMessage } from 'types/nivos-message'

type DispatchAction = (dispatch: Dispatch) => Action<Payload>

const set = (messages: NivosMessage[]): DispatchAction => {
  return (dispatch: Dispatch): Action<Payload> =>
    dispatch(
      setAction({
        loading: false,
        data: messages
      })
    )
}

const update = (message: NivosMessage): DispatchAction => {
  return (dispatch: Dispatch): Action<Payload> =>
    dispatch(
      updateAction({
        loading: false,
        data: [message]
      })
    )
}

const add = (message: NivosMessage): DispatchAction => {
  return (dispatch: Dispatch): Action<Payload> =>
    dispatch(
      addAction({
        loading: false,
        data: [message]
      })
    )
}

const loading = (loading = true): DispatchAction => {
  return (dispatch: Dispatch): Action<Payload> => dispatch(setLoading(loading))
}

export interface Operations {
  set: (messages: NivosMessage[]) => DispatchAction
  add: (message: NivosMessage) => DispatchAction
  update: (message: NivosMessage) => DispatchAction
  loading: (loading: boolean) => DispatchAction
}

const operations: Operations = {
  set,
  add,
  update,
  loading
}

export { operations, set }
